var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.featureRuleCheckEnabled && _vm.featureRuleCheckVisible)?_c('FooterRuleCheckStatus',{attrs:{"status":_vm.status,"violations":_vm.violations.length},on:{"click":_vm.onClick}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }